import axios from "axios";

const token = JSON.parse(localStorage.getItem("INFLUENCER_TOKEN"))
axios.defaults.timeout = 30000;
axios.defaults.timeoutErrorMessage='timeout'
if(token){
    axios.defaults.headers.common["x-access-token"] = token;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    Influencer(url = `${process.env.REACT_APP_BASE_URL}/api/`) {
        return {
            Login: (data) => axios.post(url +"influencer/login",data),
            Signup: (data) => axios.post(url +"influencer/signup",data),
            Reffereduser: (data) => axios.post(url +"influencer/reffereduser",data),
            Influencerdata: () => axios.get(url +"influencer/influencerdata"),
            forgotPassword: (data) => axios.post(url +"influencer/forgotpassword",data),
            verifyotp: (data) => axios.post(url +"influencer/verifyotp",data),
            updatePassword: (data) => axios.put(url +"influencer/updatePassword",data),
            changepassword: (data) => axios.put(url +"influencer/changepassword",data),
        }
    }
}